export default {
  DEBUG: false,
  QRS: {
    GatewayURL:
      'http://qrssql01.corp.archcapservices.com:8080/ArchReGwt/hello?user=aw&startPageName=viewLocationRates&introducerIdentifier=',
    GatewayNavURL:
      'http://qrssql01.corp.archcapservices.com:8080/ArchReGatewayGwt/hello',
    PowerBIReportsUrl:
      'https://app.powerbi.com/groups/me/apps/ee1e5222-fee2-4659-a01e-b4f7c9d94857/reports/cb85c2f1-57a1-4482-ba58-5d259680be40/ReportSection?ctid=441d4a8f-7999-4d6a-9670-672cf8d03e35&experience=power-bi',
  },
  //This flag is used to determine if policy renew operation to be done from FE side or server side. False value does the renew operation in FE side. True does in Server side. TODO:// Remove/change to true once BE is ready
  POLICY: {
    renewalFromServer: true,
    isPolicyReferenceNumberFeatureOn: false,
    certAndNotificationFromTransaction: true,
  },
  PROGRAM: {
    isPricingFeatureOn: true,
    isARFGenerated: true,
  },
  WORKFLOW: {
    isIRFeatureOn: true,
  },
  LOCATION: {
    locationUrl: 'https://vinta.archre.com/locations',
    auTemplatesUrl: 'https://vinta.archre.com/documents/auTemplates',
    uwTemplatesUrl: 'https://vinta.archre.com/documents/uwTemplates',
  },
  VINTA: {
    BASE_URL: 'https://vinta.archre.com',
  },
  FILER_MAILBOX_ADDRESS: 'HybridAttach_Filer@archgroup.com',
  AUTHENTICATION: {
    MODE: 'AUTH0',
    DOMAIN: 'archre.us.auth0.com',
    CLIENT_ID: 'nkesBUTyz1rsJdOBk0pUk1ISyBd6fPw3',
    CALLBACK_URL: `https://${window.location.host}/callback`,
    AUDIENCE: 'https://archway.archre.com/api',
    LOGOUT_URL: `https://${window.location.host}/`,
  },
};
